export default {
  loggingApi: {
    operation: {
      getAllLog: '/api/logging/operation/getAllLog',
      clearAll: '/api/logging/operation/clearAll',
      export: '/api/logging/operation/exportLog',
      delLogs: '/api/logging/operation/delLogs'
    },
    system: {
      getAllLog: '/api/logging/system/getAllLog',
      clearAll: '/api/logging/system/clearAll',
      export: '/api/logging/system/exportLog',
      delLogs: '/api/logging/system/delLogs'
    },
    config: {
      getList: '/api/logging/config/getList',
      addConfig: '/api/logging/config/addConfig',
      updateConfig: '/api/logging/config/updateConfig',
      enabledConfig: "/api/logging/config/enabledConfig",
      exportConfig: '/api/logging/config/exportConfig',
      delConfig: '/api/logging/config/delConfig'
    },
    userSign: {
      getUserSignLog: '/api/logging/loginSign/getUserSignLog',
      exportUserSignLog: '/api/logging/loginSign/exportUserSignLog',
      clearAll: '/api/logging/loginSign/clearAll',
      delLogs: '/api/logging/loginSign/delLogs',
    }

  }

}